import { render, staticRenderFns } from "./viewVirtual.vue?vue&type=template&id=4b8a6e6c&scoped=true&"
import script from "./viewVirtual.vue?vue&type=script&lang=js&"
export * from "./viewVirtual.vue?vue&type=script&lang=js&"
import style0 from "./viewVirtual.vue?vue&type=style&index=0&id=4b8a6e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a6e6c",
  null
  
)

export default component.exports